export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/hero.2c20a0d5-e3ca2e.png";